module.exports = __webpack_public_path__ + "img/attestation.e9ad04c5.svg";